"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = lastTypingAt;

var _simpleUpdateIn = _interopRequireDefault(require("simple-update-in"));

var _incomingActivity = require("../actions/incomingActivity");
/*eslint no-case-declarations: "off"*/

/*eslint no-unused-vars: "off"*/


var DEFAULT_STATE = {};

function lastTypingAt() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  if (type === _incomingActivity.INCOMING_ACTIVITY) {
    var _payload$activity = payload.activity,
        _payload$activity$fro = _payload$activity.from,
        id = _payload$activity$fro.id,
        role = _payload$activity$fro.role,
        activityType = _payload$activity.type;

    if (role !== 'user') {
      if (activityType === 'typing') {
        state = (0, _simpleUpdateIn["default"])(state, [id], function () {
          return Date.now();
        });
      } else if (activityType === 'message') {
        state = (0, _simpleUpdateIn["default"])(state, [id]);
      }
    }
  }

  return state;
}